import { apiClient } from 'utils/api/apiClient'
import { useCallback } from 'react'
export const useFinances = () => {
  const createOrUpdateAccount = useCallback(
    async ({
      name,
      type,
      subType,
      plaidType,
      plaidId,
      amount,
      subTypeClassification,
      typeSubTypeUuid,
      keepInRetirement,
      monthlyPayment,
      loanEndDate,
      interestRate,
      frequency,
      ieStartDate,
      policyNumber,
      balance,
      issueDate,
      carrier,
      product,
      anniversaryDate,
      signalLinked,
    }) => {
      const payload = {
        name,
        type,
        subType,
        plaidType,
        plaidId,
        amount,
        subTypeClassification,
        typeSubTypeUuid,
        keepInRetirement,
        monthlyPayment,
        loanEndDate,
        interestRate,
        frequency,
        ieStartDate,
        policyNumber,
        balance,
        issueDate,
        carrier,
        product,
        anniversaryDate,
        signalLinked,
      }

      // console.log(payload)

      const method = typeSubTypeUuid ? 'put' : 'post'
      const path = typeSubTypeUuid
        ? `/api/assets/${encodeURIComponent(typeSubTypeUuid)}`
        : '/api/assets'
      const { data } = await apiClient[method](path, payload)

      return await data
    },
    []
  )

  const createAccounts = useCallback(async (selectedAccounts) => {
    const payload = selectedAccounts
    const path = '/api/assets_many'
    const { data } = await apiClient.post(path, payload)

    return data
  }, [])

  const deleteAccount = useCallback(async ({ typeSubTypeUuid }) => {
    const path = `/api/assets/${encodeURIComponent(typeSubTypeUuid)}`
    return await apiClient.delete(path)
  }, [])

  const getAccounts = useCallback(async () => {
    const {
      data: { items },
    } = await apiClient.get('/api/assets')
    return items
  }, [])

  return {
    createOrUpdateAccount,
    createAccounts,
    deleteAccount,
    getAccounts,
  }
}
